export default __webpack_public_path__ + "static/background_schema-6a646fcf4021e2c65dca5d25c57290cd.png";